<template>
  <v-container fluid>
    <v-container fluid class="primary white--text no-gutters">
      <v-content class="mb-10">
        <v-row>
          <v-col cols="12" md="2"></v-col>
          <v-col cols="12" md="8">
            <h2 class="font-weight-bold">Sasa<span class="red--text">Pay</span> Solutions</h2>
            <div class="mt-10">
              <typewriter
                  :replace="replace"
                  :type-interval="100"
                  :replace-interval="1000"
              >
                <div>
                  <h1>SasaPay simplifies the process of collecting and disbursing money by providing a secure and easy-to-use solution.</h1>
                </div>
              </typewriter>
            </div>
            <div class="mt-10">
              <v-btn large class="error font-weight-bold rounded">Discover Our APIs</v-btn>
            </div>
          </v-col>
          <v-col cols="12" md="2">
            <v-img src="@/assets/sp/freelancer.png"/>
          </v-col>
        </v-row>
      </v-content>
    </v-container>
    <v-content class="mt-5 ">
      <v-row>
        <v-col cols="12" md="2"></v-col>
        <v-col cols="12" md="8">
          <h1>The Tools you need</h1>
          <div class="mt-2">
            <p>Build world-leading services into your business, covering payments, data, fraud, identity, loyalty, consulting and more.</p>
          </div>
        </v-col>
      </v-row>
    </v-content>
    <v-content>
      <!--BEGIN -->
      <v-row>
        <v-col class="mx-auto" cols="12" md="8">
          <v-row>
            <v-col cols="12" md="4">
               <v-card elevation="2" height="95%" class="py-10">
                <v-card-title>Customer To Business (C2B)</v-card-title>
                <v-card-text class="mt-2">
                  Customers can pay to the Business/Merchant through their SasaPay PayBills and Till Numbers.
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
               <v-card elevation="2" height="95%" class="py-10">
                <v-card-title>Business To Customer (B2C)</v-card-title>
                <v-card-text class="mt-2">
                  Business/Merchant can send money to Customers through SasaPay,MNOs,and Banks.
                </v-card-text> 
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
               <v-card elevation="2" height="95%" class="py-10">
                <v-card-title>Business To Business (B2B)</v-card-title>
                <v-card-text class="mt-2">
                  Business/Merchant can send money to other SasaPay Businesses/Merchants Tills or PayBills.
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <!--BEGIN-->
          <v-row class="mt-5">
            <v-col cols="12" md="4">
               <v-card elevation="2" height="95%" class="py-10">
                <v-card-title>Bulk Payments</v-card-title>
                <v-card-text class="mt-2">
                  A Business/Merchant has the ability to send Money to different channels.
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
               <v-card elevation="2" height="95%" class="py-10">
                <v-card-title>CASH BACK</v-card-title>
                <v-card-text class="mt-2">
                  Promote your Businesses through offers and promotions by setting cashback's
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card elevation="2" height="95%" class="py-10">
                <v-card-title>Link Payments</v-card-title>
                <v-card-text class="mt-2">
                  Payment Links Makes It Easy For You To Accept And Collect Payments.
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <!--END-->
        </v-col>
      </v-row>
      <!--END -->
    </v-content>

    <v-content class="mt-5">
      <!--BEGIN -->
      <v-row>
        <v-col class="mx-auto" cols="12" md="8">
        <v-card flat>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="8">
                <h1 class="mt-3">Discover Your Way To Success</h1>
                <div class="mt-2 py-5 line-height-4">
                  <v-divider/>
                  <h3>
                    SasaPay empowers you to make collections and disburse money in a <br/> simple, secure, and seamless way. Whether you are in search of a comprehensive payment solutions or another choice of payment for your business, we have you covered.
                  </h3>
                </div>
                <div class="mt-5">
                  <v-btn class="rounded"
                         elevation="2"
                         color="error"
                         outlined
                         @click="onSignUp"
                  >
                    Sign Up Now
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <v-img src="@/assets/sp/ipn.jpeg"/>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
          <!--END-->
        </v-col>
      </v-row>
      <!--END -->
    </v-content>
  </v-container>
</template>

<script>
import Typewriter from "typewriter-vue";
export default {
  name: "Solution",
  components: {
    Typewriter,
  },
  data: () => ({
    replace: [
      { from: "SasaPay simplifies the process of collecting and disbursing money by providing a secure and easy-to-use solution", to: "Whether you need a comprehensive payment solution for your business or are looking for an alternative payment method, we have you covered" },
    ],
  }),
  methods: {
    onSignUp(){
      window.open('https://merchant.sasapay.me/','_blank')
    }
  }
}
</script>